import './style.scss'

export default {
  name: 'HomeTeaser',
  props: ['show'],
  render (h) {
    return this.show ? (
      <aside class='HomeTeaser'>
        <router-link
          to='/weiterbildung'
          class='HomeTeaser__wrapper'
        >
          <p class='HomeTeaser__title'>frischer wind Seminare</p>
        </router-link>
      </aside>
    ) : null
  }
}



// WEBPACK FOOTER //
// ./client/components/HomeTeaser/index.js